import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { apiList } from './apiList';
import {
  languageBlockUnBlock,
  languages,
  languagesResponse,
  langugaeItems,
} from '../models/languages.models';
import { CommonResponse } from '../models/commonResponse.model';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(
    private readonly http: HttpClient,
    private _apiList: apiList
  ) {}

  getLanguages(query: string): Observable<languagesResponse> {
    return this.http
      .get<{
        data: languagesResponse;
      }>(`${this._apiList.language}?${query}`)
      .pipe(map(res => res.data));
  }

  getLanguageById(id: string): Observable<languagesResponse> {
    return this.http
      .get<{
        data: languagesResponse;
      }>(`${this._apiList.language}/${id}`)
      .pipe(map(res => res.data));
  }

  langugaeBlockUnBlock(
    data: languageBlockUnBlock,
    id: string
  ): Observable<CommonResponse> {
    return this.http
      .put<CommonResponse>(`${this._apiList.language}/${id}`, data)
      .pipe(map(res => res));
  }

  addLanguage(payload: languages): Observable<CommonResponse> {
    return this.http
      .post<{
        data: CommonResponse;
      }>(`${this._apiList.language}`, payload)
      .pipe(map(res => res.data));
  }

  updateLanguage(payload: languages, id: string): Observable<CommonResponse> {
    return this.http
      .put<{
        data: CommonResponse;
      }>(`${this._apiList.language}/${id}`, payload)
      .pipe(map(res => res.data));
  }

  sortLanguage(payload: langugaeItems[]): Observable<CommonResponse> {
    return this.http
      .patch<{
        data: CommonResponse;
      }>(`${this._apiList.languageSort}`, payload)
      .pipe(map(res => res.data));
  }

  deleteLanguage(id: string): Observable<CommonResponse> {
    return this.http
      .delete<CommonResponse>(`${this._apiList.language}/${id}`)
      .pipe(map(res => res));
  }
}
